'use client'

import { useEffect, useState } from 'react'
import type { Messages } from '@/app/messages'

// Bright red notice shown on every localized page while the backend has
// video downloads paused (VIDEO_DOWNLOADS_PAUSED_SINCE, see
// scraper/video_health.go), at the top of the page. Fetched client-side so
// static pages stay static, at the cost of the page shifting down once when
// it appears - acceptable for a temporary notice.
export default function VideoPauseBanner({ locale, t }: { locale: string; t: Messages['videoPause'] }) {
  const [since, setSince] = useState<Date | null>(null)

  useEffect(() => {
    fetch('/api/site-status')
      .then((r) => (r.ok ? r.json() : null))
      .then((d: { video_downloads_paused?: boolean; video_downloads_paused_since?: string } | null) => {
        if (d?.video_downloads_paused && d.video_downloads_paused_since) {
          const date = new Date(d.video_downloads_paused_since)
          if (!isNaN(date.getTime())) setSince(date)
        }
      })
      .catch(() => {})
  }, [])

  if (!since) return null

  const format = (timeZone?: string) =>
    new Intl.DateTimeFormat(locale, { dateStyle: 'medium', timeStyle: 'short', timeZone }).format(since)
  const body = t.body.replace('{utc}', format('UTC')).replace('{local}', format())

  return (
    <div role="status" className="shrink-0 bg-red-600 px-4 py-2.5 text-center text-sm leading-snug text-white">
      <strong className="font-semibold">⚠ {t.title}.</strong> {body}
    </div>
  )
}
